import { render, staticRenderFns } from "./WashServices.vue?vue&type=template&id=f459551e&"
import script from "./WashServices.vue?vue&type=script&lang=js&"
export * from "./WashServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports